import React, { useMemo, useState } from "react";
import Collapse from "@mui/material/Collapse";
import "./RealTimeTradeAlerts.scss";
import { realTimeAlertsData } from "./realTimeAlertsData";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";

const RealTimeTradeAlerts = ({ specificGuide, productName, telegramLink }) => {
  const [openItems, setOpenItems] = useState([]);

  const toggleItem = (index) => {
    let duplicatedItems = [...openItems];

    if (duplicatedItems.includes(index)) {
      duplicatedItems = duplicatedItems.filter((obj) => obj !== index);
    } else {
      duplicatedItems.push(index);
    }

    setOpenItems(duplicatedItems);
  };

  const updatedRealTimeAlertsData = useMemo(() => {
    return [
      ...realTimeAlertsData,
      {
        title: `Access to ${productName} Channel`,
        items: [
          {
            title: `How to join ${productName} Channel on Telegram?`,
            description: `Click on the link here to access <a href="${telegramLink}" target="_blank" class="trading-alerts-anchor"><strong>${productName} Channel</strong></a>, click on the "Join" button to request to join the channel.<br/><br/>Ensure that your Telegram username matches the name with the ${productName} subscription while pending to be accepted into the channel.<br/><br/>Once we have review and verified your real name, you will be accepted into the channel.`,
            id: 9,
          },
        ],
      },
    ];
  }, [realTimeAlertsData, telegramLink, productName]);

  return (
    <>
      <div className="common-real-time-trading-alerts-guide">
        {specificGuide
          ? specificGuide
          : `Here are 3 easy steps to setup your Telegram and access to ${productName} Telegram Channel.`}
      </div>

      {updatedRealTimeAlertsData.map((section, sectionKey) => (
        <div
          className="common-real-time-trading-alerts-section"
          key={sectionKey}
        >
          <div className="common-real-time-trading-alerts-section-title">
            {section.title}
          </div>

          {section.items.map((item) => (
            <div
              className={`common-real-time-trading-alerts-section-item ${openItems.includes(item.id) ? "active" : ""}`}
              onClick={toggleItem.bind(this, item.id)}
              key={item.id}
            >
              <div className="common-real-time-trading-alerts-section-item-main">
                {item.title}{" "}
                {openItems.includes(item.id) ? (
                  <RemoveRoundedIcon />
                ) : (
                  <AddRoundedIcon />
                )}
              </div>
              <Collapse in={openItems.includes(item.id)}>
                <div
                  className="common-real-time-trading-alerts-section-item-more"
                  dangerouslySetInnerHTML={{ __html: item.description }}
                  onClick={(e) => e.stopPropagation()}
                />
              </Collapse>
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default RealTimeTradeAlerts;
